import { useFormik } from 'formik';
import {
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../store';
import { createWhatsappLogin } from '../../../store/whatsappLogin/api';
import { setItem } from '../../../utils/localStorage';
import { useNavigate } from 'react-router-dom';
import { COUNTRY_CODE } from '../../../constants';

const LoginForm = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const {
    handleSubmit,
    resetForm,
    isSubmitting,
    handleChange,
    values,
    touched,
    errors,
    setFieldValue,
  } = useFormik({
    initialValues: {
      countryCallingCode: '+974',
      mobileNumber: '',
    },
    onSubmit: async () => {
      try {
        await dispatch(createWhatsappLogin(values)).unwrap();
        setItem('imobile', values.mobileNumber);
        setItem('icode', values.countryCallingCode);
        resetForm();
        navigate('/verify-whatsapp-otp');
      } catch (error: any) {}
    },
  });

  return (
    <form
      autoComplete='off'
      noValidate
      onSubmit={handleSubmit}
    >
      <Stack spacing={3}>
        <Grid
          container
          spacing={3}
          sx={{ width: '100%' }}
        >
          <Grid
            // item
            xs={4}
            sm={4}
            md={4}
            lg={4}
          >
            {/* <TextField
              fullWidth
              label={'Code'}
              name='countryCallingCode'
              id='countryCallingCode'
              onChange={handleChange}
              value={values.countryCallingCode}
            /> */}
            <FormControl
              sx={{
                width: { xs: '100%', sm: '100%' },
              }}
              error={Boolean(
                touched?.countryCallingCode && errors?.countryCallingCode
              )}
            >
              <InputLabel>{'Code'}</InputLabel>
              <Select
                name='countryCallingCode'
                labelId='countryCallingCode'
                id='countryCallingCode'
                value={values.countryCallingCode}
                label={'Code'}
                onChange={(e) =>
                  setFieldValue('countryCallingCode', e.target.value)
                }
                MenuProps={{
                  style: {
                    maxHeight: 400,
                  },
                }}
              >
                {COUNTRY_CODE?.map((country) => (
                  <MenuItem
                    key={country.name}
                    value={country.code}
                  >
                    {country.code} {country.name}
                  </MenuItem>
                ))}
              </Select>
              {Boolean(
                touched.countryCallingCode && errors.countryCallingCode
              ) && (
                <FormHelperText>{errors?.countryCallingCode}</FormHelperText>
              )}
            </FormControl>
          </Grid>

          <Grid
            // item
            xs={8}
            sm={8}
            md={8}
            lg={8}
            pl={2}
          >
            <TextField
              fullWidth
              label={'Mobile Number'}
              name='mobileNumber'
              id='mobileNumber'
              onChange={handleChange}
              value={values.mobileNumber}
            />
          </Grid>
        </Grid>
      </Stack>

      <Stack
        direction='row'
        alignItems='center'
        justifyContent='space-between'
        sx={{ my: 1 }}
      ></Stack>
      <Stack
        direction='row'
        alignItems='center'
        justifyContent='center'
      >
        <LoadingButton
          fullWidth
          size='large'
          type='submit'
          variant='contained'
          loading={isSubmitting}
        >
          {'Send OTP'}
        </LoadingButton>
      </Stack>
    </form>
  );
};
export default LoginForm;
